import { render } from "./create-booking-manual.vue?vue&type=template&id=527c1570&ts=true"
import script from "./create-booking-manual.vue?vue&type=script&lang=ts"
export * from "./create-booking-manual.vue?vue&type=script&lang=ts"

import "./create-booking-manual.vue?vue&type=style&index=0&id=527c1570&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__